<template>
  <div class="pl-4 pr-4 pb-4">
    <v-row class="align-center mb-2 mt-2">
      <v-col><h2 class="ma-0">{{ action === 'update' ? 'Edit policy' : 'Add policy'}}</h2></v-col>
      <v-col class="text-right"><v-icon color="primary" @click="close">mdi-close</v-icon></v-col>
    </v-row>
    <v-label>ELY Center</v-label>
    <v-select
        v-model="newItem.elyCenter"
        :items="elyCenters"
        outlined
        hide-details
        class="mb-4"></v-select>
    <v-label>Area(s)</v-label>
    <v-select
        v-model="selectedAreas"
        :items="areas"
        item-value="id"
        outlined
        hide-details
        multiple
        return-object
        class="mb-4"></v-select>
    <v-label>ISCO Class</v-label>
    <v-text-field
        label="ISCO Class"
        v-model="newItem.iscoClass"
        outlined
        hide-details
        persistent-placeholder
        placeholder=""
        single-line
        class="mb-4"></v-text-field>
    <v-label>Start date</v-label>
    <v-text-field
        label="Start date"
        v-model="selectedStartDate"
        outlined
        hide-details
        persistent-placeholder
        placeholder=""
        single-line
        type="date"
        class="mb-4"></v-text-field>
    <v-label>End date</v-label>
    <v-text-field
        label="End date"
        v-model="selectedEndDate"
        outlined
        hide-details
        persistent-placeholder
        placeholder=""
        single-line
        type="date"
        class="mb-4"></v-text-field>
    <v-label>Label - Primary</v-label>
    <v-text-field
        label="Primary label"
        v-model="newItem.label"
        outlined
        hide-details
        persistent-placeholder
        placeholder=""
        class="mb-4"></v-text-field>
    <v-label>Label - Finnish</v-label>
    <v-text-field
        label="Label - Finnish"
        v-model="newItem.labelTranslations.fi"
        outlined
        hide-details
        persistent-placeholder
        placeholder=""
        class="mb-4"></v-text-field>
    <v-label>Label - Swedish</v-label>
    <v-text-field
        label="Label - Swedish"
        v-model="newItem.labelTranslations.sv"
        outlined
        hide-details
        persistent-placeholder
        placeholder=""
        class="mb-4"></v-text-field>
    <v-label>Label - English</v-label>
    <v-text-field
        label="Label - English"
        v-model="newItem.labelTranslations.en"
        outlined
        hide-details
        persistent-placeholder
        placeholder=""
        class="mb-4"></v-text-field>
    <v-btn color="primary" @click="save" block>Save</v-btn>
  </div>
</template>

<script>
export default {
  name: 'PolicyEditor',
  props: {
    item: {
      type: Object,
      required: true,
    },
    action: {
      type: String,
      required: true,
      default: 'create',
    },
  },
  data() {
    return {
      elyCenters: [
        'Etelä-Savon ELY-keskus',
        'Hämeen ELY-keskus',
        'Kaakkois-Suomen ELY-keskus',
        'Kainuun ja Pohjois-Pohjanmaan ELY-keskus',
        'Keski-Suomen ELY-keskus',
        'Lapin ELY-keskus',
        'Pirkanmaan ELY-keskus',
        'Pohjanmaan ja Etelä-Pohjanmaan ELY-keskus',
        'Pohjois-Karjalan ELY-keskus',
        'Pohjois-Savon ELY-keskus',
        'Satakunnan ELY-keskus',
        'Uudenmaan ELY-keskus',
        'Varsinais-Suomen ELY-keskus',
      ],
      newItem: {},
    };
  },
  watch: {
    // Apply labelTranslations to item if needed
    // eslint-disable-next-line object-shorthand, func-names
    item: {
      handler(newItem) {
        console.log(newItem);
        this.newItem = JSON.parse(JSON.stringify(newItem));
        if (!this.newItem.labelTranslations) {
          this.newItem.labelTranslations = {
            fi: '',
            sv: '',
            en: '',
          };
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    areas() {
      return this.$store.state.mapData.map((area) => {
        return {
          text: area.name, value: area.id,
        };
      });
    },
    selectedAreas: {
      // eslint-disable-next-line object-shorthand, func-names
      get: function () {
        return this.newItem.areas.map((area) => {
          return { value: area.id, text: area.name };
        });
      },
      // eslint-disable-next-line object-shorthand, func-names
      set: function (val) {
        this.newItem.areas = val.map((area) => {
          return { id: area.value, name: area.text };
        });
      },
    },
    selectedStartDate: {
      // eslint-disable-next-line object-shorthand, func-names
      get: function () {
        return this.newItem.startDate.split('T')[0];
      },
      // eslint-disable-next-line object-shorthand, func-names
      set: function (val) {
        this.newItem.startDate = new Date(val).toISOString();
      },
    },
    selectedEndDate: {
      // eslint-disable-next-line object-shorthand, func-names
      get: function () {
        return this.newItem.endDate.split('T')[0];
      },
      // eslint-disable-next-line object-shorthand, func-names
      set: function (val) {
        this.newItem.endDate = new Date(val).toISOString();
      },
    },
  },
  methods: {
    async save() {
      if (this.action === 'update') {
        await this.$store.dispatch('dispatchUpdatePolicy', { policy: this.newItem });
        this.$emit('saved');
        this.$emit('close');
      } else {
        await this.$store.dispatch('dispatchPostPolicy', { policy: this.newItem });
        this.$emit('saved');
        this.$emit('close');
      }
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style>

</style>
